var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"name":function($event){return _vm.updateTitle($event)}}}),_c('router-view'),_c('Footer',{attrs:{"id":"call"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }